// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
// @/assets/style.css 與 @/assets/reset.min.css 在「取之不盡」會用到，如果要刪除，請確認所有功能皆運作正常。
import CSS from "@/assets/style.css";
import reset from "@/assets/reset.min.css";
import http from "../src/http.js";
Vue.prototype.$axios = http;

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

//vue-datime日期選擇器使用元件
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);
Vue.component("datetime", Datetime);

import VueResource from "vue-resource";
Vue.use(VueResource);

import Vuex from "vuex";
import _ from "lodash";

Vue.use(Vuex);
Vue.use(ElementUI);

import { webTypeApiUrl } from "@/constants/webTypeApiUrl";
Vue.prototype.$conf = { ...webTypeApiUrl };

//QRCode使用元件
import VueQrcode from "@chenfengyuan/vue-qrcode";
Vue.component(VueQrcode.name, VueQrcode);

//vue-select使用元件
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
Vue.component("v-select", vSelect);

//輪播需要用到的元件
import VueAwesomeSwiper from "vue-awesome-swiper";
Vue.use(VueAwesomeSwiper /* { default global options } */);
import "swiper/dist/css/swiper.css";

//vue-custom-scrollbar需要用到的元件
import vueCustomScrollbar from "vue-custom-scrollbar";
Vue.component("vue-custom-scrollbar", vueCustomScrollbar);

const emit = (vnode, name, data) => {
  var handlers =
    (vnode.data && vnode.data.on) ||
    (vnode.componentOptions && vnode.componentOptions.listeners);

  if (handlers && handlers[name]) {
    handlers[name].fns(data);
  }
};

const vChatScroll = {
  bind: (el, binding, vnode) => {
    let timeout;
    let scrolled = false;
    let scrolledTop = false;

    el.addEventListener("scroll", (e) => {
      if (timeout) window.clearTimeout(timeout);
      timeout = window.setTimeout(function () {
        scrolled = el.scrollTop + el.clientHeight + 1 < el.scrollHeight;
        if (el.scrollTop < 3) {
          emit(vnode, "scroll-top", "scroll-top");
          scrolledTop = true;
        } else {
          scrolledTop = false;
        }

        if (el.scrollTop + el.clientHeight == el.scrollHeight) {
          emit(vnode, "scroll-end", "scroll-end");
        }
      }, 200);
    });

    new MutationObserver((e) => {
      if (scrolledTop) return (el.scrollTop = 10);
    }).observe(el, { childList: true, subtree: true });
  },
};

Vue.directive("chat-scroll", vChatScroll);
//Scroll Chat End

Vue.config.productionTip = false;

// 解决在 IE 下，当 url 的 hash change 的时候浏览器没有做出相应
if (
  "-ms-scroll-limit" in document.documentElement.style &&
  "-ms-ime-align" in document.documentElement.style
) {
  // detect it's IE11
  window.addEventListener(
    "hashchange",
    function (event) {
      let currentPath = window.location.hash.slice(1);
      router.push(currentPath);
    },
    false
  );
}

//全域方法
import base from "./common"; //引用
Vue.use(base); //將全域性函式當做外掛來進行註冊

new Vue({
  el: "#app",
  router,
  components: { App },
  template: '<App :staff="staff" :accessToken="accessToken" />',
  data: {
    staff: "",
    accessToken: "",
  },
  beforeMount: function () {
    if (this.$el.attributes["staff"] != undefined) {
      this.staff = this.$el.attributes["staff"].value;
    }
    if (this.$el.attributes["accessToken"] != undefined) {
      this.accessToken = this.$el.attributes["accessToken"].value;
    }
  },
});



// WEBPACK FOOTER //
// ./src/main.js